// extracted by mini-css-extract-plugin
export default {"trainPdApplication":"styles_trainPdApplication__Gw8zq","iframeContainer":"styles_iframeContainer__zLg8M"};